module.exports = __webpack_public_path__ + "img/U1F605.4101a901.png";